import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "./routes";
import {
  FileFormat,
  ShareMode,
} from "@components/molecules/Share/components/DownloadCSVModal";
import { ProductCategory } from "@utils/constants";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import {
  ExportResult,
  ExportResults,
  ExportStatus,
} from "@src/types/ExportsResult";
import { useSelector } from "react-redux";

// Safe selector to get token without calling useUserInfo (which can crash during auth transitions)
const useToken = () => {
  return useSelector((state: any) => {
    if (!state || !state.userInfo || !state.userInfo.user) {
      return undefined;
    }
    return state.userInfo.user.token;
  });
};

export const useGetExportById = (id: number) => {
  const token = useToken();
  return useQuery({
    enabled: !!id && !!token,
    queryKey: ["GET_EXPORT_BY_ID", id],
    queryFn: () => apiClient.get<ExportResult>(Routes.EXPORTS_BY_ID(id)),
  });
};

export const useGetExports = (enabled: boolean) => {
  const token = useToken();
  return useQuery({
    enabled: !!token && enabled,
    queryKey: ["GET_EXPORTS"],
    queryFn: () => apiClient.get<ExportResults>(Routes.EXPORTS),
  });
};

export const useCreateExport = () => {
  return useMutation({
    mutationFn: (data: {
      action_type: ShareMode;
      stock_type: ProductCategory;
      price_mode: PriceModes;
      item_ids: number[];
      file_format: FileFormat;
      query: string;
      product_sub_type?: string;
      max_items?: number;
      total_items?: number;
    }) => apiClient.post<ExportResult>(Routes.EXPORTS, data),
  });
};

export const useCancelExport = (id: number) => {
  return useMutation({
    mutationFn: (data: { status: ExportStatus }) =>
      apiClient.patch<ExportResult>(Routes.EXPORTS_BY_ID(id), data),
  });
};
